/**
 * The mailbox the agent last worked in. Written by the inbox page and read wherever a support
 * surface needs a sensible default mailbox (e.g. the new-ticket modal opened outside the inbox).
 */
export const LAST_MAILBOX_STORAGE_KEY = 'admin-support-inbox-last-mailbox-id';

/**
 * Whether the agent keeps the desk ticket list at full width while reading a thread. Off by
 * default: the list sits on its rail and peeks back on hover, so the thread gets the space.
 */
export const TICKET_LIST_PINNED_STORAGE_KEY = 'admin-support-inbox-ticket-list-pinned';
